module.exports = __webpack_public_path__ + "img/m-caiwushenpi.f283927c.svg";